import { baseEnvironment } from "./environment.base";

export const environment = {
    ...baseEnvironment,
    name: "test"
};
